import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {  editPrentChildDetails, fetchChildRecord, fetchParentProfileDetails, fetchProfile, updateSelectedChild,  } from "../../../service/api";


export const getParentChildRecord = createAsyncThunk(
    "parent/getChildRecord",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchChildRecord(params)
            console.log("child record", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getParentProfileDetails = createAsyncThunk(
    "parent/getPrfileInfo",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchParentProfileDetails(params)
            console.log("parent child ", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getParentProfile = createAsyncThunk(
    "profile/parent",
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchProfile()
            console.log("parent profile", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const editSelectedChild = createAsyncThunk(
    "profile/editSelectedChild",
    async (params, { rejectWithValue }) => {
        try {
            const response = await updateSelectedChild(params)
            console.log("updated child selected", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const editParentChildInfo = createAsyncThunk(
    "profile/editParentChild",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await editPrentChildDetails(formData)
            if (response.status === 201) {
                console.log("edit child", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)



const parentSlice = createSlice({
    name: "parentProfile",
    initialState: {
        childRecord: {},
        parentProfile: {},
        parentProfileDetails: {},
        isLoading: false,
        actionLoader: false,
        error: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            //GET Child Record
            .addCase(getParentChildRecord.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getParentChildRecord.fulfilled, (state, action) => {
                state.isLoading = false;
                state.childRecord = action.payload.data;

            })
            .addCase(getParentChildRecord.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


             //GET Profile
            .addCase(getParentProfile.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getParentProfile.fulfilled, (state, action) => {
                state.isLoading = false;
                state.parentProfile = action.payload.data;

            })
            .addCase(getParentProfile.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //PUT ADMIN
            .addCase(editSelectedChild.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(editSelectedChild.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(editSelectedChild.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

             //GET Profile Details
            .addCase(getParentProfileDetails.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getParentProfileDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.parentProfileDetails = action.payload.data;

            })
            .addCase(getParentProfileDetails.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


            // //PUT
            .addCase(editParentChildInfo.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(editParentChildInfo.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(editParentChildInfo.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })



    }
})
export default parentSlice.reducer;